import { render } from "./FaQ.vue?vue&type=template&id=1db81034&scoped=true"
import script from "./FaQ.vue?vue&type=script&lang=js"
export * from "./FaQ.vue?vue&type=script&lang=js"

import "./FaQ.vue?vue&type=style&index=0&id=1db81034&scoped=true&lang=scss"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db81034"]])

export default __exports__